/* Единые правила показа чисел и дат. Меняем здесь — меняется везде. */

export const n0 = (n) => Math.round(Number(n) || 0).toLocaleString('ru-RU');
export const n1 = (n) =>
  (Number(n) || 0).toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const pct = (n) =>
  ((Number(n) || 0) * 100).toLocaleString('ru-RU', { maximumFractionDigits: n < 0.1 ? 1 : 0 }) + '%';

export const gb = (mb) => (mb >= 1024 ? n1(mb / 1024) + ' ГБ' : n0(mb) + ' МБ');
export const tb = (mb) => n1(mb / 1024 / 1024) + ' ТБ';
export const rub = (n) => n0(n) + ' ₽';

export function hrs(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  if (h >= 100) return n0(h) + ' ч';
  return h ? h + ' ч ' + m + ' мин' : m + ' мин';
}

export const plural = (n, one, few, many) => {
  const m = Math.abs(n) % 100;
  const k = m % 10;
  if (m > 10 && m < 20) return many;
  if (k === 1) return one;
  if (k > 1 && k < 5) return few;
  return many;
};

/* Даты приходят с сервера строками ISO. Показываем в московском времени — §5.6 ТЗ. */
export const asDate = (v) => (v instanceof Date ? v : new Date(v));
export const fmtDate = (v) => asDate(v).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
export const fmtDayMonth = (v) => asDate(v).toLocaleDateString('ru-RU', { day: '2-digit', month: 'short' });
export const fmtTime = (v) => asDate(v).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
export const fmtMonth = (v) => asDate(v).toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' });
export const isoDay = (v) => asDate(v).toISOString().slice(0, 10);

export const daysBetween = (a, b) => Math.round((asDate(a) - asDate(b)) / 86400000);

/* Доля дельты к предыдущему периоду; null — если сравнивать не с чем. */
export const delta = (now, prev) => (prev ? (now - prev) / prev : null);

/* «сегодня» вместо «1 дней назад» — мелочь, но глаз цепляется. */
export function ago(v) {
  const d = Math.floor((Date.now() - asDate(v)) / 86400000);
  if (d <= 0) return 'сегодня';
  if (d === 1) return 'вчера';
  return `${d} ${plural(d, 'день', 'дня', 'дней')} назад`;
}
